import { render, staticRenderFns } from "./CmgCheckoutCustomerPaymentCard.vue?vue&type=template&id=d5ff3fb2&scoped=true&lang=pug&"
import script from "./cmg-checkout-customer-payment-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-customer-payment-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutCustomerPaymentCard.vue?vue&type=style&index=0&id=d5ff3fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ff3fb2",
  null
  
)

export default component.exports